import { Card } from '../ui/card';

export const ComparisonCard = ({ currentScore }) => (
  <Card className="p-6 sm:p-8 mt-8">
    <h2 className="text-xl sm:text-2xl font-serif font-bold mb-6">Your Clarity vs Others</h2>

    <div className="space-y-4">
      <div>
        <div className="flex justify-between text-sm mb-2">
          <span className="text-gray-600">Your Clarity Score</span>
          <span className="font-semibold">{currentScore}/100</span>
        </div>
        <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-500"
            style={{ width: `${currentScore}%` }}
          />
        </div>
      </div>

      <div>
        <div className="flex justify-between text-sm mb-2">
          <span className="text-gray-600">Average User</span>
          <span className="font-semibold">42/100</span>
        </div>
        <div className="h-4 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-gray-400" style={{ width: '42%' }} />
        </div>
      </div>
    </div>

    <div className="mt-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-gray-700">
        <span className="font-semibold text-blue-600">
          You are seeing {Math.max(0, currentScore - 42)}% more clearly
        </span> than the average Clarity user. Keep reading diverse sources to improve your score!
      </p>
    </div>
  </Card>
);
